/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Explorer_Kanban_Update_State_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to update state: {error}" |
*
* @param {Explorer_Kanban_Update_State_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_kanban_update_state_failed_toast = /** @type {((inputs: Explorer_Kanban_Update_State_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Kanban_Update_State_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de la mise a jour de l'etat : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Statusaktualisierung fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile aggiornare lo stato: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось обновить состояние: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo actualizar el estado: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`更新状态失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`状態の更新に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`स्थिति अपडेट करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao atualizar o estado: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to update state: ${i?.error}`)
});